import { PhoneNumberValidator } from './phone-number-validator.js';

export class RomanianPhoneNumberValidator extends PhoneNumberValidator {
  static readonly formattedPhoneNumberFormat: RegExp = new RegExp('^(?:\\+40|0)?(?:7\\d{8})$');

  validateFormattedNumber(number: string | null): boolean {
    const sanitizedNumber = number?.replace(' ', '');
    return sanitizedNumber ? RomanianPhoneNumberValidator.formattedPhoneNumberFormat.test(sanitizedNumber) : false;
  }

  validate(number: string): boolean {
    const sanitizedNumber = this.sanitize(number);
    return sanitizedNumber ? sanitizedNumber.length === 9 : false;
  }

  sanitize(number: string): string | null {
    let sanitizedNumber = super.sanitize(number);
    if(sanitizedNumber) {
      if(sanitizedNumber.startsWith('+40')) {
        sanitizedNumber = sanitizedNumber.substring(3);
      }
      if(sanitizedNumber.startsWith('0')) {
        sanitizedNumber = sanitizedNumber.substring(1);
      }
    }

    return sanitizedNumber;
  }
}
